import { inputDescLimit, inputTextLimit } from '../../../helpers/fieldRestriction';
import messages from '../../../locale/jsonMessages';

const validate = (values, props) => {

  const errors = {};
  const activeLanguageCodes = props?.activeLanguageCodes || [];

  if (values?.dynamicStaticPage && values?.dynamicStaticPage?.length > 0) {
    values.dynamicStaticPage.forEach((value, index) => {
      const arrayErrors = {}

      const isLanguageInactive = value?.language && activeLanguageCodes.length > 0
        && !activeLanguageCodes.includes(value.language);

      if (!value?.language || value?.language.toString().trim() === '' || isLanguageInactive) {
        arrayErrors.language = messages.required;
      }

      if (!value.metaTitle || value.metaTitle.trim() == '') {
        arrayErrors.metaTitle = messages.required;
      } else if (value.metaTitle && value.metaTitle.trim() == '') {
        arrayErrors.metaTitle = messages.required;
      } else if (value?.metaTitle?.length > inputTextLimit) {
        arrayErrors.metaTitle = messages.inputTextLimitError
      }

      if (!value.metaDescription || value.metaDescription.trim() == '') {
        arrayErrors.metaDescription = messages.required;
      } else if (value.metaDescription && value.metaDescription.trim() == '') {
        arrayErrors.metaDescription = messages.required;
      } else if (value?.metaDescription?.length > inputDescLimit) {
        arrayErrors.metaDescription = messages.inputDescLimitError
      }

      const stripped = value?.content?.replace(/<[^>]+>/g, "").replace(/&nbsp;/gi, "").replace(/\s+/g, "").trim();
      if (!value.content || value.content == '<p><br></p>' || value.content == '<p> </p>' || value.content == '' || !stripped) {
        arrayErrors.content = messages.required;
      } else if (value.content && value.content.trim() == '') {
        arrayErrors.content = messages.required;
      }

      if (Object.keys(arrayErrors).length > 0) {
        errors.dynamicStaticPage = errors.dynamicStaticPage || [];
        errors.dynamicStaticPage[index] = arrayErrors;
      }
    })
  }

  return errors
}

export default validate
